import { render, staticRenderFns } from "./_custom.vue?vue&type=template&id=65dc3682&"
import script from "./_custom.vue?vue&type=script&lang=js&"
export * from "./_custom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports